import { awardedContracts } from "./mock";
import withAwardsNTenders from "../HOC/withAwardsNTenders";
import withHeaderFooterHOC from "../HOC/withHeaderFooterHOC";

const HomeAwardedContracts = () => withAwardsNTenders(null)({ data: awardedContracts, title: "contracts" });

export default withHeaderFooterHOC(HomeAwardedContracts);
